module.exports = __webpack_public_path__ + "img/scala.0ca42c25.png";